import React from "react";
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";

const PettyCashComponent = () => {
  return (
    <div className="petty-cash">
      <Container fluid>
        <Outlet />
      </Container>
    </div>
  );
};
export default PettyCashComponent;
